import validate from './validate';

const validators = {
  has4Digits: value => /^\d{4}$/i.test(value)
};

const validatorsLive = {
  has4Digits: value => /^\d{1,4}$/i.test(value)
};

const validationErrors = {
  has4Digits: 'Must be 4 digits!'
};

export const checkVerificationCodeLive = (
  betSlipNumber => validate(betSlipNumber, validatorsLive, validationErrors)
);

export const checkVerificationCode = (
  betSlipNumber => validate(betSlipNumber, validators, validationErrors)
);

export default checkVerificationCode;
